module.exports = __webpack_public_path__ + "img/car_0004.3eb9ced6.jpg";